// Extract URL from description if it starts with "Original URL: "
export function extractUrlFromDescription(description: string | undefined): string | null {
  try {
    if (!description || typeof description !== 'string') return null
    const urlMatch = description.match(/^Original URL:\s*(.+?)(?:\n\n|$)/)
    if (urlMatch && urlMatch[1]) {
      const url = urlMatch[1].trim()
      // Add https:// if URL doesn't start with http:// or https://
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return `https://${url}`
      }
      return url
    }
    return null
  } catch (error) {
    return null
  }
}

// Helper function to normalize hostname
export function normalizeHostname(hostname: string): string {
  return hostname.replace('www.', '')
}

// Helper function to format common job site names
export function formatJobSiteName(hostname: string): string | null {
  if (hostname.includes('linkedin.com')) {
    return 'LinkedIn'
  }
  if (hostname.includes('indeed.com')) {
    return 'Indeed'
  }
  if (hostname.includes('glassdoor.com')) {
    return 'Glassdoor'
  }
  return null
}

// Helper function to extract domain from URL using regex fallback
export function extractDomainFromUrlRegex(url: string): string {
  const match = url.match(/https?:\/\/(?:www\.)?([^/]+)/)
  if (match && match[1]) {
    const hostname = normalizeHostname(match[1])
    const formattedName = formatJobSiteName(hostname)
    return formattedName || hostname
  }
  return url.replace(/^https?:\/\//, '')
}

export function getDomainFromUrl(url: string): string {
  try {
    const urlObj = new URL(url)
    const hostname = normalizeHostname(urlObj.hostname)
    const formattedName = formatJobSiteName(hostname)
    return formattedName || hostname
  } catch (error) {
    // Fallback: try to extract domain manually
    return extractDomainFromUrlRegex(url)
  }
}
